import { render, staticRenderFns } from "./RoundImage.vue?vue&type=template&id=27921caa&scoped=true&"
import script from "./RoundImage.vue?vue&type=script&lang=js&"
export * from "./RoundImage.vue?vue&type=script&lang=js&"
import style0 from "./RoundImage.vue?vue&type=style&index=0&id=27921caa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27921caa",
  null
  
)

export default component.exports